<template>
    <div
        v-if="content.length > 0"
        class="md btn-list"
        :class="[align? 'is-'+ align: '', block? 'is-block': '']"
    >
        <ul><slot></slot><li
            v-for="item in content"
            :key="JSON.stringify(item)"
        >
            <cpBtn
                v-bind="item"
                @sendEvent="receiveEvent"
            ></cpBtn>
        </li></ul>
    </div>
</template>

<script>
    import cpBtn from '@/components/cpBtn'

    export default {
        components: {
            cpBtn,
        },
        props: {
            align: {
                type: String,
                required: false,
                default: ''
            },
            block: {
                type: Boolean,
                required: false,
                default: false
            },
            content: {
                type: Array,
                required: false,
                default: function(){
                    return []
                }
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.btn-list {

        .g.pop-up-content + & { //popup
            flex-shrink: 0;
            padding: $interval-m $interval-xxl $interval-xl;
            
        }

        &.is-block {
            display: block;

            li {

                a {
                    display: block;
                }
            }
        }

        ul {
            @extend %reset;
            display: flex;

            @include media('mobile') {
                display: block;
            }
        }

        li {
            
            &:first-child {
                flex: 1
            }

            + li {
                margin-left: $interval-s;

                @include media('mobile') {
                    margin-top: $interval-s;
                    margin-left: 0;
                }
            }
        }

        a {
           display: inline-block; 

            @include media('mobile') {
                display: block;
            }
        }
    }
</style>
